import { Component, OnInit, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';

import { PersonalService } from '../../Service/personal-service'; // Ajusta la ruta
import { ToastService } from '../../Service/toast-service';

@Component({
  selector: 'app-personal-add',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './personal-add.html',
  styleUrl: './personal-add.css',
})
export class PersonalAdd implements OnInit {
  personalForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private personalService: PersonalService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<PersonalAdd>,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    // Inicialización del formulario reactivo con validaciones estrictas
    this.personalForm = this.fb.group({
      nameAlpha: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(255)]],
      searchType: ['', Validators.required], // 'E' o 'M'
      email: ['', [Validators.email, Validators.maxLength(255)]],
      phone: ['', [Validators.pattern('^[0-9+ ]*$'), Validators.maxLength(50)]]
    });

    if (isPlatformBrowser(this.platformId)) {
      console.log('📶 [SaaS Personal] Inicializado panel de captura física en Chrome.');
    }
  }

  onSubmit(): void {
    if (this.personalForm.invalid) {
      this.personalForm.markAllAsTouched();
      this.toastService.showDanger('Formulario Incompleto', 'Por favor, complete los campos obligatorios en rojo.');
      return;
    }

    const rawValue = this.personalForm.getRawValue();

    // Estructura idéntica al Map<String, String> que espera el controlador de Spring Boot
    const nuevoPersonal = {
      nameAlpha: rawValue.nameAlpha.trim().toUpperCase(),
      searchType: rawValue.searchType,
      email: rawValue.email ? rawValue.email.trim().toUpperCase() : '',
      phone: rawValue.phone ? rawValue.phone.trim() : ''
    };

    console.log('>>> [SECURITY JDE] Despachando alta de personal a Spring Boot:', nuevoPersonal);

    this.personalService.registrarPersonal(nuevoPersonal).subscribe({
      next: (res) => {
        //this.toastService.showSuccess('Registro Exitoso', `Identidad creada correctamente en el Address Book.`);
        //this.dialogRef.close(res || true); // Cierra regresando la respuesta con el nuevo AN8
        this.dialogRef.close(res);
      },
      error: (err) => {
        console.error('Error al registrar personal en el servidor:', err);
        this.toastService.showDanger(
          'Fallo de Inserción',
          err.error?.error || 'No se pudo guardar la identidad física. Intente de nuevo.'
        );
        this.cdr.detectChanges();
      }
    });
  }

  onCancelar(): void {
    this.dialogRef.close(false);
  }
}
